<template>
    <q-page>
        <div class="q-pa-md row items-start q-gutter-md row">
            <q-card class="my-card full-width">
                <div>
                    <h4 class="text-h4">
                        <q-icon name="fas fa-broadcast-tower" class="q-pl-md q-pr-xs"></q-icon>
                        {{ webcast.title }}
                    </h4>
                </div>

                <q-card-separator />

                <q-card-main class="row q-pa-md">
                    <div class="text-body1 col-12 q-pl-md q-pb-md">{{webcast.description}}</div>
                    <div class="text-subtitle2 col-12 q-pl-md">{{ $t('webcast_start_schedule') }}: <strong>{{ fDateTime(webcast.transmission_date) }}H</strong></div>
                </q-card-main>

                <q-card-separator />

                <q-card-actions class="row justify-end q-pa-md">
                    <q-btn color="tertiary" class="col-4" :label="$t('back')" :icon="getIconBtn('back')" @click="closeModal" />
                    <q-btn color="primary" class="col-4" :label="$t('start')" :icon="getIconBtn(activity)" @click="gotoClass(webcast.webcast_id)"  />
                </q-card-actions>
            </q-card>
        </div>



        <q-modal v-if="show_modal_webcast" v-model="show_modal_webcast" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalWebcast()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ selected_webcast.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <webcast v-if="show_modal_webcast" :webcast="selected_webcast" :live="firebase_webcast_data" />
            </q-modal-layout>
        </q-modal>

    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { db } from 'plugins/vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'


export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'courses', 'presential', 'webcast' ] },

    props: ['activity', 'event_date_id', 'presential_event_id'],

    data() {
        return {
            webcast: '',
            title: '',
            description: '',
            firebase_webcast_data: '',
            loading: false,
            show_modal_webcast: false,
            selected_webcast: {},
        }
    },

    components: {
        'webcast': () => import('components/webcasts/Webcast.vue'),
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        async gotoClass() {
            try {
                this.$q.loading.show()
                const response = await this.$axios.get(`/etraining_presential/presential/${this.presential_event_id}/presential_event_date/${this.event_date_id}/open_class/`, this.getHeader)
                if (response.status === 200) {
                    this.selected_webcast = this.webcast
                    this.show_modal_webcast = true
                    this.setUserOnlineFirebase()
                }
            } catch (e) {
                this.$q.notify({
                    message: this.$t('webcast_not_available_yet_info'),
                    type: 'warning',
                    icon: 'far fa-clock',
                    position: 'bottom'
                })
                console.log(e)
            } finally {
                this.$q.loading.hide()
            }
        },

        hideModalWebcast() {
            this.show_modal_webcast = false
            this.setUserOfflineFirebase()
        },

        closeModal() {
            this.$emit('closeModal')
        },

        getIconBtn(activity) {
            if (activity.type_slug === 'webcast') return 'far fa-eye'
            else return 'fas fa-chevron-left'
        },

        setUserOnlineFirebase() {
            if (this.selected_webcast.status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/webcast_user_status/${this.webcast.webcast_id}/${uid}`)
                let userOnline = firebase.database().ref(`/webcast_user_online/${uid}`)

                let isOnlineForDatabase = {
                    st: 'on',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.webcast.webcast_id.toString())
                }

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.webcast.webcast_id)
                }

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userStatus.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userStatus.set(isOnlineForDatabase)
                    })
                })

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userOnline.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userOnline.set(isOnlineForDatabase)
                    })
                })
            }
        },

        setUserOfflineFirebase() {
            if (this.selected_webcast.status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/webcast_user_status/${this.webcast.webcast_id}/${uid}`)
                let userOnline = firebase.database().ref(`/webcast_user_online/${uid}`)

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.webcast.webcast_id)
                }

                userStatus.set(isOfflineForDatabase)
                userOnline.set(isOfflineForDatabase)
            }
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY - HH:mm'
                    break
                    default: format = 'MM-DD-YYYY - HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },
    },

    beforeDestroy () {
        if (this.show_modal_webcast) {
            this.setUserOfflineFirebase()
        }
    },

    beforeRouteLeave (to, from, next) {
        if (this.show_modal_webcast) {
            this.setUserOfflineFirebase()
        }
        next()
    },

    mounted () {
        if (this.webcast.webcast_type === 2 && !this.webcast.transmission_completed) {
            this.$bind('firebase_webcast_data', db.collection('webcast').doc(`${this.webcast.webcast_id}`)).then(data => {
                this.firebase_webcast_data === data
            })
        }
    },

    created() {
        this.webcast = this.activity
    },
}
</script>

<style>

</style>
